/**
 * Nosto Slider
 * ------------------------------------------------------------------------------
 * Nosto Slider component
 *
 * @namespace nostoSlider
 */

import Carousel from './carousel';

/**
 * DOM selectors.
 */
const selectors = {
  carouselContainer: '[js-nosto="carousel"]',
  carouselCell: '[js-nosto="slide"]',
};

/**
 * Create a new example object.
 * @param {object} config - Settings object defined when instantiating.
 */
export default () => {
  let carousel = {};

  /**
   * Initialize component.
   */
  function init() {
    nostoListener();
  }

  /**
   * Initialize carousel.
   */
  function initCarousel() {
    const nosto_elements = document.querySelectorAll('.nosto_element');
    nosto_elements.forEach(function(nosto_element) {
      if (nosto_element.querySelectorAll(selectors.carouselContainer).length > 0 ) {
        var nosto_element_carousel = '#' + nosto_element.getAttribute('id') + ' ' + selectors.carouselContainer;
        carousel = Carousel(nosto_element_carousel, {
          cellSelector: '[js-nosto="slide"]',
          pageDots: true,
          prevNextButtons: true,
        });

        carousel.init();
      }
    })

    // carousel = Carousel(selectors.carouselContainer, {
    //   cellSelector: selectors.carouselCell,
    //   pageDots: true,
    //   prevNextButtons: true,
    // });

    // carousel.init();
  }
  function initCarouselYouMayAlsoLike() {
    const nosto_elements = document.querySelectorAll(".nosto_element_you_may_also_like");
    nosto_elements.forEach(function(nosto_element) {
      if (nosto_element.querySelectorAll(selectors.carouselContainer).length > 0 ) {
        var nosto_element_carousel = '#' + nosto_element.getAttribute('id') + ' ' + selectors.carouselContainer;
        carousel = Carousel(nosto_element_carousel, {
          cellSelector: '[js-nosto="slide"]',
          pageDots: true,
          prevNextButtons: true,
        });

        carousel.init();

        $(".iWishAddColl.iwishcheck").on("click", function(e) {
          e.preventDefault();
          var iWishvId = jQ(this).attr("data-variant");
          iwish_addCollection(jQ(this), iWishvId);
          return false;
        });
        iwishCheckColl();
      }
    });
  }
  function initCarouselRecentlyViewed() {
    const nosto_elements = document.querySelectorAll('.nosto_element_recently_viewed');
    nosto_elements.forEach(function(nosto_element) {
      if (nosto_element.querySelectorAll(selectors.carouselContainer).length > 0 ) {
        var nosto_element_carousel = '#' + nosto_element.getAttribute('id') + ' ' + selectors.carouselContainer;
        carousel = Carousel(nosto_element_carousel, {
          cellSelector: '[js-nosto="slide"]',
          pageDots: true,
          prevNextButtons: true,
        });

        carousel.init();

        $(".iWishAddColl.iwishcheck").on("click", function(e) {
          e.preventDefault();
          var iWishvId = jQ(this).attr("data-variant");
          iwish_addCollection(jQ(this), iWishvId);
          return false;
        });
        iwishCheckColl();
      }
    })
  }

  /**
   * Nosto callback function
   */
  function nostoListener() {
    // window.nostojs((api) => {
      // api.listen("postrender", () => {
        initCarousel();

        setTimeout(function() {
          initCarouselYouMayAlsoLike();
        }, 2000);

        // setTimeout(function() {
        //   initCarouselRecentlyViewed();
        // }, 3000);

        function waitForElm(selector) {
          return new Promise(resolve => {
            if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
              }
            });

            observer.observe(document.body, {
              childList: true,
              subtree: true
            });
          });
        }
        waitForElm(".nosto_element_recently_viewed .product-card").then(elm => {
          // console.log("Element is ready");
          // console.log(elm.textContent);

          setTimeout(function() {
            initCarouselRecentlyViewed();
          }, 3000);
        });

        // var checkExist = setInterval(function() {
        //   if (document.querySelector('.nosto_element_recently_viewed .product-card') != null) {
        //     console.log("Exists!");
        //     clearInterval(checkExist);

        //     setTimeout(function() {
        //       initCarouselRecentlyViewed();
        //     }, 3000);
        //   }
        // }, 500);

      // });
    // });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
